(() => {
  if (window.AtomizedCartDiscount) return;

  const ROOT = window.Shopify?.routes?.root || '/';
  const CART_URL = window.routes?.cart_url || `${ROOT}cart`;
  const UPDATE_URL = window.routes?.cart_update_url || `${ROOT}cart/update`;
  let operation = Promise.resolve();

  const jsonUrl = (url) => (url.endsWith('.js') ? url : `${url}.js`);

  async function request(url, options = {}, attempt = 0) {
    const response = await fetch(url, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json', ...(options.headers || {}) },
      ...options,
    });

    if ((response.status === 429 || response.status >= 500) && attempt < 2) {
      await new Promise((resolve) => setTimeout(resolve, 400 * (attempt + 1)));
      return request(url, options, attempt + 1);
    }

    const payload = await response.json().catch(() => ({}));
    if (!response.ok || payload.status >= 400) {
      throw new Error(payload.description || payload.message || 'No fue posible actualizar el cupón.');
    }
    return payload;
  }

  const fetchCart = () => request(jsonUrl(CART_URL));
  const appliedCodes = (cart) =>
    Array.isArray(cart.discount_codes)
      ? cart.discount_codes.filter((discount) => discount.applicable).map((discount) => discount.code)
      : [];

  async function refreshCart(cart) {
    const response = await fetch(`${ROOT}?sections=cart-drawer,cart-icon-bubble`, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    });
    if (!response.ok) throw new Error('No fue posible refrescar el carrito.');

    const sections = await response.json();
    const drawer = document.querySelector('cart-drawer');
    if (drawer && sections['cart-drawer']) {
      drawer.classList.toggle('is-empty', cart.item_count === 0);
      if (typeof drawer.renderContents === 'function') {
        drawer.renderContents({ id: null, sections });
      }
    }

    if (sections['cart-icon-bubble']) {
      const parsed = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
      const source = parsed.querySelector('.shopify-section');
      const target = document.querySelector('#cart-icon-bubble');
      if (source && target) target.innerHTML = source.innerHTML;
    }
  }

  function enqueue(task) {
    const next = operation.then(task, task);
    operation = next.catch(() => undefined);
    return next;
  }

  function setStatus(message, error = false) {
    document.querySelectorAll('[data-atomized-discount-status]').forEach((node) => {
      node.textContent = message;
      node.classList.toggle('is-error', error);
    });
  }

  function setApplyLoading(loading) {
    document.querySelectorAll('[data-atomized-discount-button]').forEach((button) => {
      button.disabled = loading;
      button.textContent = loading ? 'Aplicando…' : 'Aplicar';
    });
  }

  async function applyDiscountCore(code) {
    const cleanCode = code.trim();
    if (!cleanCode) throw new Error('Ingresa un código de descuento.');

    const before = await fetchCart();
    const previousCodes = appliedCodes(before);
    const requestedCodes = [...new Set([...previousCodes, cleanCode])];
    const updated = await request(jsonUrl(UPDATE_URL), {
      method: 'POST',
      body: JSON.stringify({ discount: requestedCodes.join(',') }),
    });
    const returnedCode = Array.isArray(updated.discount_codes)
      ? updated.discount_codes.find((discount) => discount.code.toLowerCase() === cleanCode.toLowerCase())
      : null;

    if (!returnedCode || !returnedCode.applicable) {
      await request(jsonUrl(UPDATE_URL), {
        method: 'POST',
        body: JSON.stringify({ discount: previousCodes.join(',') }),
      });
      throw new Error('El código no es válido o no aplica a este carrito.');
    }

    await refreshCart(updated);
    document.querySelectorAll('[data-atomized-discount-form] [name="discount"]').forEach((input) => {
      input.value = '';
    });
    setStatus(`Código ${cleanCode} aplicado.`);
  }

  async function removeDiscountCore(code) {
    const before = await fetchCart();
    const remainingCodes = appliedCodes(before).filter(
      (appliedCode) => appliedCode.toLowerCase() !== code.trim().toLowerCase()
    );
    const updated = await request(jsonUrl(UPDATE_URL), {
      method: 'POST',
      body: JSON.stringify({ discount: remainingCodes.join(',') }),
    });
    await refreshCart(updated);
    setStatus(`Código ${code} eliminado.`);
  }

  const applyDiscount = (code) => enqueue(() => applyDiscountCore(code));
  const removeDiscount = (code) => enqueue(() => removeDiscountCore(code));
  const showError = (error) => setStatus(error?.message || 'No fue posible actualizar el cupón.', true);

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('[data-atomized-discount-form]');
    if (!form) return;
    event.preventDefault();
    setApplyLoading(true);
    setStatus('');
    applyDiscount(form.querySelector('[name="discount"]')?.value || '')
      .catch(showError)
      .finally(() => setApplyLoading(false));
  }, true);

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-atomized-remove-discount]');
    if (!button) return;
    event.preventDefault();
    const code = button.dataset.atomizedRemoveDiscount || '';
    button.disabled = true;
    setStatus('');
    removeDiscount(code)
      .catch(showError)
      .finally(() => {
        button.disabled = false;
      });
  }, true);

  window.AtomizedCartDiscount = { applyDiscount, removeDiscount };
})();
